import * as React from "react";

import { getRelevantSuggestions } from "@agent-ui/features/page-renderer/components/navbar/promptSuggestionData";
import { CornerDownLeft } from "lucide-react";

function PromptSuggestions({
  searchQuery,
  onSelect,
  onHover,
}: {
  searchQuery: string;
  onSelect: (prompt: string) => void;
  onHover: (prompt: string | null) => void;
}) {
  const suggestions = React.useMemo(
    () => getRelevantSuggestions({ query: searchQuery }),
    [searchQuery],
  );

  if (suggestions.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col">
      {suggestions.map((suggestion) => {
        const fullPrompt = `Build me a ${suggestion.prompt}`;
        return (
          <button
            key={suggestion.prompt}
            type="button"
            className="group flex items-center justify-between px-4 py-3 text-left text-sm hover:bg-sheet transition-colors cursor-pointer border-b-0.5 border-border last:border-b-0 w-full"
            onClick={() => onSelect(fullPrompt)}
            onMouseEnter={() => onHover(fullPrompt)}
            onMouseLeave={() => onHover(null)}
          >
            <span className="text-muted">Build me a </span>
            <span className="font-semibold text-default">
              {suggestion.prompt}
            </span>
            <CornerDownLeft
              size={14}
              className="text-muted opacity-0 group-hover:opacity-100 transition-opacity shrink-0 ml-3"
            />
          </button>
        );
      })}
    </div>
  );
}

export default PromptSuggestions;
